import React from 'react'
import Cache from '@aws-amplify/cache'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import App from './components/App'
import { store } from './store'

import './assets/styles/tailwind.css'
import './assets/styles/index.scss'

Cache.configure({ capacityInBytes: 5000000, defaultTTL: 86400000 })

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
